export default "__VITE_ASSET__CzqX6SBH__"